import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import styles from './Subscription.module.css';
import CategoryPicker from "../components/CategoryPicker";
import { Subscription as SubscriptionModel } from "../models/Subscription";

export default function Subscription() {

    const [searchParams] = useSearchParams();
    const [sub, setSub] = useState<SubscriptionModel>();
    const [categories, setCategories] = useState<string[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [success, setSuccess] = useState<string>('');
    const [error, setError] = useState<string>('');
    const token = searchParams.get("token");

    useEffect(() => {
        fetchSub();
    }, []);

    useEffect(() => {
        if(sub?.category == 'all') {
            sub!.category = '';
        }
        setCategories(sub?.category.split(';') ?? []);
    }, [sub]);

    const fetchSub = async () => {
        try {
            const response = await fetch(`/api/subscriptions/${token}`);
            if (!response.ok) {
                throw new Error("Abonnement introuvable.");
            }
            const data = await response.json();
            setSub(data);
        }
        catch(err: any) {
            setError(err.message || "Erreur lors du chargement de l'abonnement.");
        }
        finally {
            
        }
    };

    const saveChanges = async () => {
        setLoading(true);
        setSuccess('');
        setError('');
        try {
            let cats = categories.join(';');
            if(cats == '') {
                cats = 'all';
            }
            const response = await fetch(`/api/subscriptions`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    token: token,
                    category: cats
                })
            });
            if (!response.ok) {
                throw new Error();
            }

            setSuccess("Changements enregistrés :)");
        }
        catch(err) {
            setError("Une erreur s'est produite lors de l'enregistrement.");
        }
        finally {
            setLoading(false);
        }
    };

    const unsub = async () => {
        setLoading(true);
        setSuccess('');
        setError('');
        try {
            const response = await fetch(`/api/subscriptions/unsubscribe`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({token: token})
            });
            if (!response.ok) {
                throw new Error();
            }

            setSuccess("Tu n'es maintenant plus abonné.e :(");
            
        } catch (err: any) {
            setError("Une erreur s'est produite lors du désabonnement.");
        } finally {
            setLoading(false);
        }
    };

    return <>
        <h1>Mon abonnement</h1>
        {!token && <p>Une erreur s'est produite.</p>}

        {!sub?.isActive && <p>Tu n'es actuellement pas abonné.e.</p>}

        {categories && !!sub?.isActive && <CategoryPicker selectedCategories={categories} onChange={(cats) => setCategories(cats)}/>}

        {token && !!sub?.isActive && <button className={styles.btn} type="button" disabled={loading} onClick={() => saveChanges()}>Enregistrer</button>}

        {token && !success && !!sub?.isActive && <p><button className={styles.unsubBtn} type="button" disabled={loading} onClick={() => unsub()}>Se désabonner</button></p>}
        {success && <p>
            <div>{success}</div>
            <Link to={"/"}><button className={styles.btn} type="button">Retour à l'accueil</button></Link>
        </p>}
        {error && <p>{error}</p>}
        <br/>
        <br/>
        <br/>
    </>;
}